module.exports = __webpack_public_path__ + "img/837ff2e.jpg";